import userInfo from "./userInfo";
import settingData from './settingData';
import { combineReducers } from "redux";
import { searchFilterReducerSlice } from "./searchFilterSlice";
import { postInfoSlice } from "./postInfoSlice";

export default combineReducers({
  userInfo,
  settingData,
  searchFilter: searchFilterReducerSlice.reducer,
  postInfo: postInfoSlice.reducer,

});